<ng-container [ngSwitch]="column.type">
  <ng-container *ngSwitchCase="'project'">
    <asax-result-table-search-table-cell-project [projectCode]=value>
    </asax-result-table-search-table-cell-project>
  </ng-container>
  <ng-container *ngSwitchCase="'asdms'">
    <asax-result-table-search-table-cell-asdms [numberAsdms]="value"
                                               [datasetId]="row.id">
    </asax-result-table-search-table-cell-asdms>
  </ng-container>
  <ng-container *ngSwitchCase="'observations'">
    <asax-result-table-search-table-cell-observations [numberObservations]="value"
                                                      [projectCode]="row.code"
                                                      [bibCode]="row.bibCode">
    </asax-result-table-search-table-cell-observations>
  </ng-container>
  <ng-container *ngSwitchCase="'frequency-support'">
    <asax-result-table-search-table-cell-frequency-support [freqMin]="row.freqMin"
                                                           [freqMax]="row.freqMax"
                                                           [datasetId]="row.id">
    </asax-result-table-search-table-cell-frequency-support>
  </ng-container>
  <ng-container *ngSwitchCase="'publications'">
    <asax-result-table-search-table-cell-publications [numberPublications]="value"
                                                      [projectCode]="row.project?.code || row.id">
    </asax-result-table-search-table-cell-publications>
  </ng-container>
  <ng-container *ngSwitchCase="'bib-code'">
    <asax-result-table-search-table-cell-publication [bibCode]="value">
    </asax-result-table-search-table-cell-publication>
  </ng-container>
  <ng-container *ngSwitchCase="'projects'">
    <asax-result-table-search-table-cell-projects [numberProjects]="value"
                                                  [bibCode]="row.bibCode">
    </asax-result-table-search-table-cell-projects>
  </ng-container>
  <ng-container *ngSwitchCase="'release-date'">
    <asax-result-table-search-table-cell-release-date [releaseDate]="value"
                                                      [row]="row">
    </asax-result-table-search-table-cell-release-date>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-container *ngIf="(column.name == 'Gal.lon.' 
      || column.name == 'Gal.lat.'
      || column.name == 'Ecl.lon.'
      || column.name == 'Ecl.lat.'
      ); else notGalLotOrLon">
      {{ value | number:'1.0-6' }}
    </ng-container>
    <ng-template #notGalLotOrLon>
      <ng-container *ngIf="column.units; else valueWithoutUnits">
        {{value | unitsFormatter: (columnUnitsObservable | async)}}
      </ng-container>
      <ng-template #valueWithoutUnits>
        <div #tooltip="ngbTooltip"
            [ngbTooltip]="tooltipText"
            triggers="manual"
            placement="top"
            container="body"
            [autoClose]="false"
            (mouseover)="openWithTimeout()"
            (mouseleave)="closeWithTimeout()">
          <div #cellText [innerHTML]="value" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"></div>
        </div>
      </ng-template>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #tooltipText>
  <div (mouseover)="clearTimeout()"
       (mouseleave)="closeWithTimeout()"
       [innerHTML]="value">
  </div>
</ng-template>

